import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "./store/store"
import { ReactNode } from "react"

export interface ContextMenuPosition {
    x: number
    y: number
}

export interface ContextMenuItem {
    name: string
    action: () => void
    icon?: ReactNode
    textStyle?: string
}

export interface ContextMenuState {
    position: ContextMenuPosition | null
    items: ContextMenuItem[]
}

interface ShowContextMenuPayload {
    position: ContextMenuPosition
    items: ContextMenuItem[]
}

const name = "contextMenuSlice"
const initialState: ContextMenuState = { position: null, items: [] }
const contextMenuSlice = createSlice({
    name,
    initialState,
    reducers: {
        showContextMenu: (
            state,
            action: PayloadAction<ShowContextMenuPayload>
        ) => {
            state.position = action.payload.position
            state.items = action.payload.items
        },
        hideContextMenu: (state) => {
            state.position = null
            state.items = []
        }
    }
})

export const { showContextMenu, hideContextMenu } = contextMenuSlice.actions

export const selectContextMenuPosition = (state: RootState) =>
    state.contextMenu.position
export const selectContextMenuItems = (state: RootState) =>
    state.contextMenu.items

export default contextMenuSlice.reducer
